import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { FileCheck2, Plus } from 'lucide-react';
import { Container, Eyebrow, H2, Reveal, btn } from './shared';
import { useSiteConfig } from '../../lib/siteConfig';

export const Freebie = () => {
  const { checklist_url } = useSiteConfig();
  return (
    <section id="checkliste" className="scroll-mt-20 bg-paper py-20 sm:py-24" data-testid="freebie-section">
      <Container>
        <Reveal className="grid items-center gap-8 rounded-[28px] border border-line bg-navy p-7 sm:p-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
          <div>
            <Eyebrow>Noch nicht so weit?</Eyebrow>
            <H2>Hol dir meine kostenlose Aktien-Checkliste.</H2>
            <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg">
              Die Fragen, die ich mir vor jedem Kauf stelle. Auf einer Seite, zum Ausdrucken. Dazu ab und zu eine Analyse per Mail.
            </p>
          </div>
          <div>
            <FileCheck2 size={40} strokeWidth={1.4} className="mb-5 hidden text-brand lg:block" aria-hidden="true" />
            <a href={checklist_url} className={`${btn.navy} w-full px-8 text-base sm:min-h-[56px]`} data-testid="freebie-checklist-btn">
              Checkliste kostenlos holen
            </a>
            <p className="mt-3 text-center text-xs leading-relaxed text-ink">Eintragen, E-Mail bestätigen, Checkliste kommt direkt in dein Postfach.</p>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

const faqs = (price) => [
  ['Brauche ich Vorwissen?', 'Nein. Wir starten bei null. Wenn du schon einen ETF-Sparplan hast, umso besser. Nötig ist es nicht.'],
  ['Bekomme ich konkrete Aktientipps?', 'Nein, und genau das ist der Punkt. Du lernst, selbst zu entscheiden. Das Mentoring ist Bildung, keine Anlageberatung.'],
  ['Wie viel Zeit brauche ich neben dem Job?', 'Drei Live-Calls pro Woche plus etwas Übung. Die Termine stimmen wir gemeinsam ab, sodass sie zu deinem Arbeitsalltag passen.'],
  ['Warum nur 4 Wochen?', 'Weil du danach selbstständig analysieren sollst und nicht von mir abhängig sein. Checkliste, DCF-Modell und alle Unterlagen behältst du.'],
  ['Ist das ein Abo?', `Nein. ${price} € einmalig für die kompletten 4 Wochen, keine versteckten Kosten.`],
  ['Wann bezahle ich?', 'Erst nach dem Kennenlern-Call, wenn wir beide sagen: Das passt.'],
];

export const Faq = () => {
  const { price } = useSiteConfig();
  return (
    <section id="faq" className="scroll-mt-20 bg-paper py-20 sm:py-28" data-testid="faq-section">
      <Container className="max-w-[860px]">
        <Reveal>
          <Eyebrow>FAQ</Eyebrow>
          <H2>Häufige Fragen</H2>
        </Reveal>
        <Accordion.Root type="single" collapsible className="mt-10 divide-y divide-line border-y border-line">
          {faqs(price).map(([q, a], i) => (
            <Accordion.Item key={q} value={`faq-${i}`}>
              <Accordion.Header>
                <Accordion.Trigger className="faq-trigger group flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left font-display text-lg font-bold text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-testid={`faq-trigger-${i}`}>
                  {q}
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full border border-line transition-colors group-data-[state=open]:bg-brand group-data-[state=open]:text-paper">
                    <Plus size={18} className="transition-transform duration-300 group-data-[state=open]:rotate-45" aria-hidden="true" />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="faq-content overflow-hidden" data-testid={`faq-content-${i}`}>
                <p className="pb-6 pr-12 text-base leading-relaxed text-ink">{a}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </Container>
    </section>
  );
};
